/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Components
import { Typography } from "@mui/material";
import Box from "@mui/material/Box";

import { useTranslation } from "react-i18next";

function HelpModalScreen() {
  const { t } = useTranslation(["help"]);

  return (
    <Box sx={{ overflow: "scroll", overflowX: "hidden", maxHeight: "85vh", padding: "1rem" }}>
      <Typography variant="h1" mb={2}>
        {t("dso_list.title")}
      </Typography>
      <hr />

      <Typography variant="h3" mt={4} ml={2}>
        {t("dso_list.inj_grid.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("dso_list.inj_grid.body")}
        </Box>
      </Typography>

      <Typography variant="h3" mt={4} ml={2}>
        {t("dso_list.inj_storage.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("dso_list.inj_storage.body")}
        </Box>
      </Typography>

      <Typography variant="h3" mt={4} ml={2}>
        {t("dso_list.shared_energy.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("dso_list.shared_energy.body")}
        </Box>
      </Typography>

      <Typography variant="h3" mt={4} ml={2}>
        {t("dso_list.imputed_energy.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("dso_list.imputed_energy.body")}
        </Box>
      </Typography>

      <Typography variant="h3" mt={4} ml={2}>
        {t("dso_list.surplus.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("dso_list.surplus.body")}
        </Box>
      </Typography>

      <Typography variant="h3" mt={4} ml={2}>
        {t("dso_list.consumption.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("dso_list.consumption.body")}
        </Box>
      </Typography>

      <Typography variant="h3" mt={4} ml={2}>
        {t("dso_list.self_consumption.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("dso_list.self_consumption.body")}
        </Box>
      </Typography>
    </Box>
  );
}

export default HelpModalScreen;
